<app-pay-profile *ngIf="english"></app-pay-profile>
<app-pay-profile-hindi *ngIf="hindi"> </app-pay-profile-hindi>